import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AdvancedSearchContainerData, AdvancedSearchFormData, Filters, KeyValue, KeyValueI } from '../../models/common';
import { KanbanSearchAdvancedFormComponent } from '../kanban-search-advanced-form/kanban-search-advanced-form.component';
import { KanbanSearchTagFilterDataComponent } from '../kanban-search-tag-filter-data/kanban-search-tag-filter-data.component';


@Component({
  selector: 'antera-lib-kanban-search-advanced',
  templateUrl: './kanban-search-advanced.component.html',
  styleUrls: ['./kanban-search-advanced.component.scss']
})
export class KanbanSearchAdvancedComponent implements OnInit {

  // TODO  add savedsearch strcture
  // @Input() savedSearch: {} = {};
  @Input() advancedSearchFormData: AdvancedSearchFormData = {
    title: '', // ie "Filters"
    description: '', // ie: ""
    filters: []
  }


  @Input() anteraFilterOptions: KeyValue[] = [];
  @Input() advancedSearchContainerData:AdvancedSearchContainerData = {
    advancedSearchContainer: '',
    titleAdvancedSearch: '',
    excerptAdvancedSearch: ''
  };
  @Input() page: string = '';


  @Output() public advancedSearchSavedValues: EventEmitter<any> = new EventEmitter();

  @ViewChild('tagForm') public tagForm: KanbanSearchTagFilterDataComponent = {} as KanbanSearchTagFilterDataComponent;
  @ViewChild('filterForm') public filterForm: KanbanSearchAdvancedFormComponent = {} as KanbanSearchAdvancedFormComponent;
  @Output() public autoComplete: EventEmitter<any> = new EventEmitter();
  @Input() public showProductDeleted: number = 0;
  @Input() public reSynceNeeded = false;
  @Output() public ontToggleResyncQBO: EventEmitter<any> = new EventEmitter();
  @Output() public onToggleAccountType: EventEmitter<any> = new EventEmitter();
  @Input() public qboActive = false;
  @Input() public mappingFields: any[] =  [];

  constructor() { }

  ngOnInit(): void {
  }


  /**
   * Emits the values of the advanced search form.
   *
   * @returns {void}
   */
  public saveAdvancedSearch(): void{
    // TODO Clean this function up
    const tagValue = this.tagForm.anteraFilterForm.value;
    const tagName = this.anteraFilterOptions.find((tag:KeyValueI) => tag.value === tagValue)?.key;
    // const tagFormValues = {key: th ,value: this.tagForm.anteraFilterForm.value };
    const tagFormValues = {tagName, tagValue};
    const filterFormValues = this.filterForm.advancedSearchFormData.filters;
    const showProductDeleted = {isDeleted: this.showProductDeleted};

    // filterFormValues.forEach((filter: Filters) => filter.value = (filter?.type === 'calendar' && moment(filter?.value)) || filter.value)

    const savedValues = {
      tag: tagFormValues,
      showProductDeleted: showProductDeleted,
      ...JSON.parse(JSON.stringify(filterFormValues))
    };

    this.advancedSearchSavedValues.emit(savedValues);
    this.tagForm.anteraFilterForm.patchValue('');
    // TODO MIGHT be unnecessary
    this.filterForm.advancedSearchFormData.filters.forEach((filter) => filter.value = '');
    this.filterForm.radioValues.forEach((radiovalue: string) => radiovalue = '');
  }

  inputValueChange(event: any) {
    this.autoComplete.emit(event);
  }

  public toggleResyncQBO(event: any) {
    this.ontToggleResyncQBO.emit(event);
  }

  public changeAccType(event: any) {
    this.onToggleAccountType.emit(event);
  }
}
